<template>

  <section id="bidmarket_body">   
      <div id="inner_bidmarket">       
        <div class="wrapper_logobm">           
          <center>
            <img v-bind:src="config.SITE_LOGO" :alt="config.SITE_NAME" />
          </center>
        </div>       
         <transition name="fade" mode="out-in">
         <component v-bind:is="view" v-on:change-component-view="changeComponentView"></component>
       </transition>
      </div>    
    </section> 
   
</template>


 <script>

   import SignIn from '@/components/SignIn';
   import ForgotPassword from '@/components/ForgotPassword';
  import siteConfiguration from '@/config';

   export default {

     data() {
       return {
         view: 'sign-in',
         config: siteConfiguration
       };
     },
     methods: {
       changeComponentView(name){
         this.view = name;
       }
     },
     components: {
       'sign-in': SignIn,
       'forgot-password': ForgotPassword
     }
   };
  
 </script>




// WEBPACK FOOTER //
// src/components/views/Login.vue